module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('FilterPageList', {
    attrs: {
      "data": _vm.unableFailoverJobsList,
      "total": _vm.total,
      "order-by": _vm.orderBy,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form', {
          staticClass: "table-filter",
          attrs: {
            "inline": true
          }
        }, [_c('input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          attrs: {
            "type": "text"
          }
        }), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": ""
          }
        }, [_c('el-input', {
          attrs: {
            "placeholder": "请输入作业名"
          },
          nativeOn: {
            "keyup": function($event) {
              if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
              scope.search($event)
            }
          },
          model: {
            value: (_vm.filters.jobName.value),
            callback: function($$v) {
              _vm.$set(_vm.filters.jobName, "value", $$v)
            },
            expression: "filters.jobName.value"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-search"
          },
          on: {
            "click": scope.search
          }
        }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
          staticClass: "page-table"
        }, [_c('div', {
          staticClass: "page-table-header"
        }, [_c('div', {
          staticClass: "page-table-header-title"
        }, [_c('i', {
          staticClass: "fa fa-list"
        }), _vm._v("无法高可用的作业\n                    "), _c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": _vm.refreshList
          }
        }, [_c('i', {
          staticClass: "fa fa-refresh"
        })])], 1)]), _vm._v(" "), _c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "stripe": "",
            "border": "",
            "data": scope.pageData
          },
          on: {
            "sort-change": scope.onSortChange
          }
        }, [_c('el-table-column', {
          attrs: {
            "prop": "jobName",
            "label": "作业名",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_setting',
                    params: {
                      domain: scope.row.domainName,
                      jobName: scope.row.jobName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.jobName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "domainName",
            "label": "所属域",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('router-link', {
                attrs: {
                  "tag": "a",
                  "to": {
                    name: 'job_overview',
                    params: {
                      domain: scope.row.domainName
                    }
                  }
                }
              }, [_c('el-button', {
                attrs: {
                  "type": "text"
                }
              }, [_vm._v("\n                                " + _vm._s(scope.row.domainName) + "\n                            ")])], 1)]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "degree",
            "label": "域等级",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.degree]) + "\n                    ")]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "jobDegree",
            "label": "作业等级",
            "sortable": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_vm._v("\n                        " + _vm._s(_vm.$map.degreeMap[scope.row.jobDegree]) + "\n                    ")]
            }
          }])
        })], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d3fb79f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/unableFailoverJobs.vue
// module id = 1394
// module chunks = 1